import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';

import { LoginComponent } from './containers/login/login.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { CompanyComponent } from './containers/company/company.component';
import { UserComponent } from './containers/user/user.component';
import { CreateCompanyComponent } from './containers/create-company/create-company.component';
import { CompanyItemComponent } from './components/company-item/company-item.component';
import { CompanyFilterComponent } from './components/company-filter/company-filter.component';
import { CoreModule } from '../core/core.module';
import { CompanyFormComponent } from './forms/company-form/company-form.component';
import { UserFormComponent } from './forms/user-form/user-form.component';
import { CompanyDetailComponent } from './containers/company-detail/company-detail.component';
import { TariffComponent } from './containers/tariff/tariff.component';
import { UserDetailComponent } from './containers/user-detail/user-detail.component';
import { CreateUserComponent } from './containers/create-user/create-user.component';
import { TariffDetailComponent } from './containers/tariff-detail/tariff-detail.component';
import { UserLiftPermissionComponent } from './containers/user-lift-permission/user-lift-permission.component';
import { UserFilterComponent } from './components/user-filter/user-filter.component';
import { CreateTariffComponent } from './containers/create-tariff/create-tariff.component';
// Translate
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [LoginComponent, LoginFormComponent, CompanyComponent, UserComponent, CreateCompanyComponent, CompanyItemComponent, CompanyFilterComponent, CompanyFormComponent, UserFormComponent, CompanyDetailComponent, TariffComponent, UserDetailComponent, CreateUserComponent, TariffDetailComponent, UserLiftPermissionComponent, UserFilterComponent, CreateTariffComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    NgbTypeaheadModule,
    TranslateModule
  ],
  exports: [
    LoginComponent
  ]
})
export class UserModule { }
